import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface YearSlice {
    years: number[];
    selectedYear?: number;
}

const initialState = { years: [], selectedYear: undefined } satisfies YearSlice as YearSlice;

const yearSlice = createSlice({
    name: 'years',
    initialState,
    reducers: {
        setSelectedYear: (state, action: PayloadAction<number>) => {
            state.selectedYear = action.payload;
        },
        setYears: (state, action: PayloadAction<number[]>) => {
            state.years = action.payload;
        },
    },
});

export const { setYears, setSelectedYear } = yearSlice.actions;

export default yearSlice.reducer;

// const store = configureStore({
//     reducer: {
//         years: yearSlice.reducer,
//     },
// });
//
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
//
// export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
// export const useAppDispatch = () => useDispatch<AppDispatch>();
